<style>
  #MyListMenu li {
    list-style: none;
  }

  .Lvl2 {
    margin: 10px 20px;
  }
</style>
<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Add User</h5>

    <button type="button" (click)="openModal_Customer(templatePersone)" class="btn btn-warning"
      style="margin-right: 5px;"> Search Personnel <i class="fa fa-user"></i> </button>

    <br>
    <br>

    <form *ngIf="selected_DataList_Persone_Record.id>0" [formGroup]="AddNewUser" (submit)="SubmitAddNewUser()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Username</label>
          <input formControlName="Username" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Username().valid && get_Form_Username().touched"
            class="form-text text-muted MyErrorRedColor">Enter the username.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Password</label>
          <input formControlName="Password" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Password().valid && get_Form_Password().touched"
            class="form-text text-muted MyErrorRedColor">Enter a password of at least 6 characters.</small>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Type User </label>
          <select formControlName="Type" class="custom-select">
            <option value="0">Select</option>
            <option value="1">Administrator</option>
            <option value="2">Standard User</option>
          </select>
        </div>
        <div class="form-group col-md-6" *ngIf="get_Form_Type().value!='1'">
          <label for="exampleInputEmail1"> Calibration Data Access </label>
          <select formControlName="ExpertCalibration" class="custom-select">
            <option value="0">Assigned Data</option>
            <option value="1">All Data</option>
          </select>
        </div>
        <div class="form-group col-md-6" *ngIf="get_Form_Type().value=='1'">
          <label for="exampleInputEmail1"> Calibration Data Access </label>
          <p>All Data</p>
        </div>

      </div>



      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewUser.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
      <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i
          class="fa fa-times-rectangle"></i> Cancel </button>
      <button routerLink="/User" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>
    <button routerLink="/User" *ngIf="selected_DataList_Persone_Record.id==0" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> Back </button>
  </div>
</div>


<ng-template #templatePersone>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Personnel List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Person.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Name/Last Name </label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Full Name</th>
              <th>Abbreviation in Behineh Farayand Azma</th>
              <th>National ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Persone
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Persone|filter:Filter_title:'fullname').length
                      }
            ">
              <td>{{DataList_Persone.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.almat_Ekhtesari}}</td>
              <td>{{item.codemeli}}</td>

              <td (click)="selected_DataList_Persone(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingPersone" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingPersone" type="button" (click)="ReadData_Persone()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Person.hide()">Close</button>
  </div>
</ng-template>
